import axiosInstance, { getApiUrl, ApiKeys } from '@cp/src/utils/ApiHelper';
import { Dispatch } from '@reduxjs/toolkit';
import { setCallLimitHistory } from './reducer/callLimitSlice';
import { isFunction } from '@cp/src/utils/commonUtils';
import { getFileDownload } from '@cp/src/utils/commonUtils';
import { REQUEST_SUB_TYPE } from './types';
import { API_STATUS_CODE } from '@cp/src/utils/ApiHelperUtils';
import { toast } from '@navi/web-ui/lib/primitives/Toast';

export const fetchCallLimitHistory = (
  pageNo: number,
  pageSize: number,
  loadingCb?: (loading: boolean) => void
) => {
  const url = getApiUrl(ApiKeys.GET_REALLOCATION_HISTORY);
  if (isFunction(loadingCb)) {
    loadingCb(true);
  }
  return (dispatch: Dispatch) => {
    axiosInstance
      .get(url, {
        params: { pageNo, pageSize, requestSubType: REQUEST_SUB_TYPE }
      })
      .then(response => {
        if (response) {
          dispatch(setCallLimitHistory(response?.data));
          if (isFunction(loadingCb)) {
            loadingCb(false);
          }
        }
      });
  };
};

export const fetchCallLimitOriginalFile = (referenceId: string) => {
  const url = getApiUrl(ApiKeys.DOWNLOAD_ALLOCATION_ORIGINAL_FILE, { referenceId });
  return () => {
    axiosInstance.get(url).then(response => {
      if (response?.data) {
        const fileUrl = response?.data;
        getFileDownload(fileUrl);
      }
    });
  };
};

export const fetchCallLimitFailureReport = (referenceId: string) => {
  const url = getApiUrl(ApiKeys.GET_ALLOCATION_FAILURE_REPORT, { referenceId });
  return () => {
    axiosInstance.get(url).then(response => {
      if (response?.data) {
        const fileUrl = response?.data;
        getFileDownload(fileUrl);
      }
    });
  };
};

export const fetchCallLimitSampleFile = () => {
  const url = getApiUrl(ApiKeys.GET_ALLOCATION_ORIGINAL_FILE, { type: REQUEST_SUB_TYPE });
  return () => {
    axiosInstance.get(url).then(response => {
      if (response?.data) {
        const fileUrl = response?.data?.data;
        getFileDownload(fileUrl);
      }
    });
  };
};

export const uploadCallLimitFile = (file: File | null) => {
  if (!file) {
    return { error: true, message: 'No file provided for upload.', success: false };
  }
  const url = getApiUrl(ApiKeys.CALL_LIMIT_UPLOAD, { donotHandleError: 'true' });
  const formData = new FormData();
  formData.append('file', file);
  const response = axiosInstance.put(url, formData);
  return response.then(response => {
    if (response.status === API_STATUS_CODE.ACCEPTED || response.status === API_STATUS_CODE.OK) {
      toast('File uploaded successfully!', { type: 'success' });
      return { success: true, message: '', error: false };
    } else {
      toast(response.data.title, { type: 'error' });
      return { error: true, message: response.data.title, success: false };
    }
  });
};
